import { z } from "zod";

import { THEME } from "../../components/ui/ThemeToggler/theme.types";

import { LANGS_VALUES_MAP } from "../../modules/i18n";

export const userRoleGroupSchema = z.object({
  id: z.number().optional(),
  internal_id: z.string().optional(),
  slug: z.string(),
  name: z.string(),
  is_primary: z.boolean().optional(),
  permissions: z.array(z.string()).nullable().optional(),
});

export const userAppSettingsSchema = z.object({
  theme: z.nativeEnum(THEME),
  lng: z.nativeEnum(LANGS_VALUES_MAP),
});

export const userSchema = z.object({
  id: z.union([z.string(), z.number()]),
  internal_id: z.string().min(1),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  email: z.string().email(),
  full_name: z.string(),
  role_group: z.array(userRoleGroupSchema),
  created_on: z.string().datetime(),
  is_first_password_updated: z.boolean(),
  is_staff: z.boolean(),
  is_superuser: z.boolean(),
  country_code: z.string()?.optional(),
  country_locale: z.string()?.optional(),
  group_by_agent_report: z.array(z.string()),
  entity: z.object({
    internal_id: z.string().min(1),
    name: z.string().min(1),
    slug: z.string().min(1),
  }),
  employee: z.object({
    internal_id: z.string().min(1),
    first_name: z.string().nullable(),
    last_name: z.string().nullable(),
  }),
});

export const userTokenSchema = z.object({
  refresh_token: z.string().min(1),
  refresh_token_expiration: z.number().optional(),
  access_token: z.string().min(1),
  access_token_expiration: z.number(),
  access: z.string().min(1).optional(),
});

// Complete response schema
export const userResponseSchema = z.object({
  status: z.boolean(),
  message: z.string(),
  data: userSchema,
});

// TypeScript types inferred from the schemas
export type TUser = z.infer<typeof userResponseSchema>;
export type TUserDataSchema = z.infer<typeof userSchema>;
export type TUserRoleGroup = z.infer<typeof userRoleGroupSchema>;
export type TUserToken = z.infer<typeof userTokenSchema>;

export type TUpdateUserRequestPayload = RecursivePartial<TUser>;
